import { Property } from '../../../../types/property';
import { Response } from '../../../../types/response';
import PropertyCarousel from '../../../molecules/PropertyCarousel/PropertyCarousel';
import { londonCityGuidePropertyCarouselProps } from './types';
import useGet from '../../../../services/useGet';
import { useEffect, useState } from 'react';
import { isEmpty } from '../../../../utils/utils';
import './LiveLikeALocalPropertyCarousel.scss';

function LiveLikeALocalPropertyCarousel(props: londonCityGuidePropertyCarouselProps) {
  const { title, subtitle, city } = props;
  const [properties, setProperties] = useState<Property[]>([]);
  const [propertyResult, getProperty] = useGet<Response>({
    url: `/properties`,
    defaultValue: {},
    queryParams: {
      location: city
    }
  });

  useEffect(() => {
    if (city) getProperty();
  }, [city]);

  useEffect(() => {
    !isEmpty(propertyResult) && setProperties(propertyResult.properties);
    !isEmpty(propertyResult) && console.log(propertyResult);
  }, [propertyResult]);

  return (
    <section className="london-city-guide-carousel-section">
      <div className="container london-city-guide-container">
        <div className="row">
          <div className="col-lg-12 text-left london-city-guide-heading">
            <h2 className="title">{title}</h2>
            <h4 className="subtitle">{subtitle}</h4>
          </div>
        </div>
      </div>
      {!!properties.length && <PropertyCarousel properties={properties} />}
    </section>
  );
}
export default LiveLikeALocalPropertyCarousel;
